export const ONE_DRIVE_CONUSMER_BASE_URLS = 'https://1drv.ms';
